import { FC, useEffect, useRef } from 'react';
import {
    Column,
    ColumnDirective,
    ColumnsDirective,
    CommandColumn,
    CommandModel,
    Edit,
    Filter,
    FilterSettingsModel,
    Grid,
    GridComponent,
    Inject,
    Page,
    QueryCellInfoEventArgs,
    RowDataBoundEventArgs,
    SelectionSettingsModel,
    Sort,
} from '@syncfusion/ej2-react-grids';
import { getValue, Internationalization } from '@syncfusion/ej2-base';
import { useDispatch, useSelector } from 'react-redux';
import { setRowData, setRowId } from './gridReducer';
import { getDefaultFilterOperator, pageOptions } from './gridConfig';
import './Grid.scss';
import { RootState } from '../../redux/store';
import { getTabData } from '../contactTabs/utils';
import axios from 'axios';
import { ContactType } from '../contactTabs/constants';
import notify from '../../services/toasterService';
import {
    setSelectedRCIdForBin,
    setSelectedRecrdsExport,
} from '../contactTabs/contactReducer';
import { setSelectedIdForCancel } from '../invoices/invoiceReducer';
import { setGridRefInfo } from './gridReducer';

const FilterOptions: FilterSettingsModel = {
    columns: [],
    type: 'FilterBar',
    mode: 'Immediate',
    showFilterBarStatus: true,
    immediateModeDelay: 10,
    operators: {},
    showFilterBarOperator: true,
    ignoreAccent: true,
};
const editSettings = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    allowEditOnDblClick: false,
};
const commands: CommandModel[] = [
    {
        buttonOption: {
            content: 'Active',
            cssClass: 'eg-btn-success',
        },
    },
];

interface IGridWrapper {
    config: any[];
    data: any[];
    width?: string;
    height?: string;
    onRowSelect?: (selectedRecords: any[]) => void;
    onRowDeselect?: (selectedRecords: any[]) => void;
    onPaging?: (pageno: number) => void;
    onDelete?: (selectedRecords: any[]) => void;
    pageConfig?: { pageNO: number; totalRecords: number; totalPages: number };
    pageNo?: number;
    hideSpinner?: boolean;
    isFromInvoice?: boolean;
    isFromScanHistory?: boolean;
    onCheckBox?: (rowId: number) => void;
    onFilter?: (text: string) => void;
    allowFilters?: boolean;
    allowSorting?: boolean;
}

// @ts-ignore
const GridWrapper: FC<IGridWrapper> = ({
    config,
    data,
    onRowSelect,
    onRowDeselect,
    onPaging,
    onDelete,
    onCheckBox,
    onFilter,
    isFromInvoice,
    isFromScanHistory = false,
    width = '',
    height = '434',
    pageConfig = { pageNO: 0, totalRecords: 0, totalPages: 0 },
    pageNo = 1,
    hideSpinner,
    allowFilters = true,
    allowSorting = true,
}) => {
    // @ts-ignore
    //let gridRef: Grid | null = useRef(null);
    // const gridRef = useRef<GridComponent | null>(null);
    // let dataArray = [];
    // let pageNo = pageConfig.pageNO;
    // dataArray.push(data);
    let gridRef: Grid | null = useRef(null);
    const dispatch = useDispatch();
    let intl = new Internationalization();
    //let pageNo = pageConfig.pageNO;
    let selectedRow: any[];
    const tabNameForRow = useSelector(
        (state: RootState) => state.contactReducer.tabNameForRowData
    );
    const tabIndexValue = useSelector(
        (state: RootState) => state.invoiceReducer.selectedArInvoiceTabIndex
    );
    useEffect(() => {
        if (gridRef) {
            dispatch(setGridRefInfo(gridRef));
            gridRef?.clearFiltering();
        }
    }, [tabIndexValue, isFromInvoice]);
    const customizeCell = (args: any) => {
        if (
            (args.column as Column).field === 'activeForGrid' &&
            args.data &&
            args.cell
        ) {
            if (getValue('activeForGrid', args.data) === 'Active') {
                args.cell.innerHTML = `<span class='btnActiveClass'>${getValue(
                    'activeForGrid',
                    args.data
                )}</span>`;
            } else if (
                getValue('activeForGridVendor', args.data) === 'Active'
            ) {
                args.cell.innerHTML = `<span class='btnActiveClass'>${getValue(
                    'activeForGridVendor',
                    args.data
                )}</span>`;
            } else if (getValue('activeForGrid', args.data) === 'Open') {
                args.cell.innerHTML = `<span class='btnActiveClass'>${getValue(
                    'activeForGrid',
                    args.data
                )}</span>`;
            } else if (getValue('activeForGrid', args.data) === 'Approved') {
                args.cell.innerHTML = `<span class='btnApprovedClass'>${getValue(
                    'activeForGrid',
                    args.data
                )}</span>`;
            } else if (getValue('activeForGrid', args.data) === 'Denied') {
                args.cell.innerHTML = `<span class='btnDeniedClass'>${getValue(
                    'activeForGrid',
                    args.data
                )}</span>`;
            } else if (
                getValue('activeForGridVendor', args.data) === 'InActive'
            ) {
                args.cell.innerHTML = `<span class='btnInActiveClass'>${getValue(
                    'activeForGridVendor',
                    args.data
                )}</span>`;
            } else {
                args.cell.innerHTML = `<span class='btnInActiveClass'>${getValue(
                    'activeForGrid',
                    args.data
                )}</span>`;
            }
        }
        if (
            (args.column as Column).field === 'locationEnabledForGrid' &&
            args.data &&
            args.cell
        ) {
            if (getValue('locationEnabledForGrid', args.data) === 'Yes') {
                args.cell.innerHTML = `<span class='btnActiveClass'>${getValue(
                    'locationEnabledForGrid',
                    args.data
                )}</span>`;
            } else {
                args.cell.innerHTML = `<span class='btnActiveNoClassPallet'>${getValue(
                    'locationEnabledForGrid',
                    args.data
                )}</span>`;
            }
        }
        if (
            (args.column as Column).field === 'invoiceRaisedForGrid' &&
            args.data &&
            args.cell
        ) {
            if (getValue('invoiceRaisedForGrid', args.data) === 'Yes') {
                args.cell.innerHTML = `<span class='btnActiveClass'>${getValue(
                    'invoiceRaisedForGrid',
                    args.data
                )}</span>`;
            } else {
                args.cell.innerHTML = `<span class='btnActiveNoClassPallet'>${getValue(
                    'invoiceRaisedForGrid',
                    args.data
                )}</span>`;
            }
        }
        if (
            (args.column as Column).field === 'activeForGridItemCatalog' &&
            args.data &&
            args.cell
        ) {
            if (getValue('activeForGridItemCatalog', args.data) === 'Yes') {
                args.cell.innerHTML = `<span class='btnActiveClass'>${getValue(
                    'activeForGridItemCatalog',
                    args.data
                )}</span>`;
            } else {
                args.cell.innerHTML = `<span class='btnActiveNoClassPallet'>${getValue(
                    'activeForGridItemCatalog',
                    args.data
                )}</span>`;
            }
            if (
                (args.column as Column).field === 'status' &&
                args.data &&
                args.cell
            ) {
                if (getValue('status', args.data) === 'Cancelled') {
                    args.cell.innerHTML = `<span class='btnInActiveClass'>${getValue(
                        'status',
                        args.data
                    )}</span>`;
                } else if (
                    getValue('status', args.data) === 'Ready for Salvager'
                ) {
                    args.cell.innerHTML = `<span class='btnActiveClass'>${getValue(
                        'status',
                        args.data
                    )}</span>`;
                } else if (getValue('status', args.data) === 'Draft') {
                    args.cell.innerHTML = `<span class='btnDraftClass'>${getValue(
                        'status',
                        args.data
                    )}</span>`;
                } else if (
                    getValue('status', args.data) === 'Ready for Extract'
                ) {
                    args.cell.innerHTML = `<span class='btnActiveClass'>${getValue(
                        'status',
                        args.data
                    )}</span>`;
                }
                // else if (
                //   getValue("status", args.data) === "Pickup, Manual Override"
                // ) {
                //   args.cell.innerHTML = `<span class='btnPickupClass'>${getValue(
                //     "status",
                //     args.data
                //   )}</span>`;
                // }
            }
        }

        // if ((args.column as Column).field === "delete" && args.data && args.cell) {
        //   if (getValue("delete", args.data) === "delete") {
        //     args.cell.innerHTML = `<span class='deleteItem'><p class='e-icons e-delete'></p></span>`;
        //   }
        // }

        if (
            (args.column as Column).field === 'status' &&
            args.data &&
            args.cell
        ) {
            if (getValue('status', args.data) === 'Cancelled') {
                args.cell.innerHTML = `<span class='btnCancelledClass'>${getValue(
                    'status',
                    args.data
                )}</span>`;
            } else if (getValue('status', args.data) === 'Ready Slvg') {
                args.cell.innerHTML = `<span class='btnReadySlvgClass'>${getValue(
                    'status',
                    args.data
                )}</span>`;
            } else if (getValue('status', args.data) === 'Draft') {
                args.cell.innerHTML = `<span class='btnDraftClass'>${getValue(
                    'status',
                    args.data
                )}</span>`;
            } else if (getValue('status', args.data) === 'Ready Extrct') {
                args.cell.innerHTML = `<span class='btnReadyExtctClass'>${getValue(
                    'status',
                    args.data
                )}</span>`;
            } else if (getValue('status', args.data) === 'Pickup Mnul') {
                args.cell.innerHTML = `<span class='btnPickupClass'>${getValue(
                    'status',
                    args.data
                )}</span>`;
            } else if (getValue('status', args.data) === 'Pickup Auto') {
                args.cell.innerHTML = `<span class='btnPickupClass'>${getValue(
                    'status',
                    args.data
                )}</span>`;
            } else if (getValue('status', args.data) === 'Pickup, Hold') {
                args.cell.innerHTML = `<span class='btnPickupClass'>${getValue(
                    'status',
                    args.data
                )}</span>`;
            } else if (getValue('status', args.data) === 'Final Close') {
                args.cell.innerHTML = `<span class='btnFinalCloseClass'>${getValue(
                    'status',
                    args.data
                )}</span>`;
            } else if (getValue('status', args.data) === 'Picked') {
                args.cell.innerHTML = `<span class='btnPickedClass'>${getValue(
                    'status',
                    args.data
                )}</span>`;
            } else if (getValue('status', args.data) === 'Released') {
                args.cell.innerHTML = `<span class='btnReleasedClass'>${getValue(
                    'status',
                    args.data
                )}</span>`;
            } else if (getValue('status', args.data) === 'In Process') {
                args.cell.innerHTML = `<span class='btnInProcessCMClass'>${getValue(
                    'status',
                    args.data
                )}</span>`;
            } else if (getValue('status', args.data) === 'Approved') {
                args.cell.innerHTML = `<span class='btnApprovedCMClass'>${getValue(
                    'status',
                    args.data
                )}</span>`;
            } else if (getValue('status', args.data) === 'Rejected') {
                args.cell.innerHTML = `<span class='btnRejectedCMClass'>${getValue(
                    'status',
                    args.data
                )}</span>`;
            }
        }
        if (
            (args.column as Column).field === 'activeFlagBinException' &&
            args.data &&
            args.cell
        ) {
            if (getValue('activeFlagBinException', args.data) === 'Active') {
                args.cell.innerHTML = `<span class='btnActiveClass'>${getValue(
                    'activeFlagBinException',
                    args.data
                )}</span>`;
            } else {
                args.cell.innerHTML = `<span class='btnInActiveClass'>${getValue(
                    'activeFlagBinException',
                    args.data
                )}</span>`;
            }
        }
        if (
            (args.column as Column).field === 'authorizationFlagGrid' &&
            args.data &&
            args.cell
        ) {
            if (getValue('authorizationFlagGrid', args.data) === 'Yes') {
                args.cell.innerHTML = `<span class='btnActiveClass'>${getValue(
                    'authorizationFlagGrid',
                    args.data
                )}</span>`;
            } else {
                args.cell.innerHTML = `<span class='btnActiveNoClassPallet'>${getValue(
                    'authorizationFlagGrid',
                    args.data
                )}</span>`;
            }
        }

        if (
            (args.column as Column).field === 'cost' &&
            args.data &&
            args.cell
        ) {
            let nFormatter = intl.getNumberFormat({
                skeleton: 'C3',
                currency: 'USD',
                minimumIntegerDigits: 0,
                minimumFractionDigits: 2,
            });

            args.cell.innerHTML = `$${nFormatter(getValue('cost', args.data))}`;
        }

        if (
            (args.column as Column).field === 'price' &&
            args.data &&
            args.cell
        ) {
            let nFormatter = intl.getNumberFormat({
                skeleton: 'C3',
                currency: 'USD',
                minimumIntegerDigits: 0,
                minimumFractionDigits: 2,
            });

            args.cell.innerHTML =
                args?.data?.pricingType === 'Percent'
                    ? `${nFormatter(getValue('price', args.data))}%`
                    : `$${nFormatter(getValue('price', args.data))}`;
            args.cell.innerHTML = `$${nFormatter(
                getValue('price', args.data)
            )}`;
        }

        // if ((args.column as Column).field === "binPrice" && args.data && args.cell) {
        //   let nFormatter = intl.getNumberFormat({
        //     skeleton: "C3",
        //     currency: "USD",
        //     minimumIntegerDigits: 0,
        //     minimumFractionDigits: 2,
        //   });

        //   args.cell.innerHTML = args?.data?.pricingType === 'Percent'
        //   ?  `${nFormatter(getValue("binPrice", args.data))}%`
        //   : `$${nFormatter(getValue("binPrice", args.data))}`;
        //   args.cell.innerHTML = `$${nFormatter(getValue("binPrice", args.data))}`;
        // }

        if (
            (args.column as Column).field === 'priceCommodity' &&
            args.data &&
            args.cell
        ) {
            let nFormatter = intl.getNumberFormat({
                skeleton: 'C3',
                currency: 'USD',
                minimumIntegerDigits: 0,
                minimumFractionDigits: 2,
            });

            args.cell.innerHTML =
                args?.data?.pricingType === 'Percent'
                    ? `${nFormatter(getValue('priceCommodity', args.data))}%`
                    : `$${nFormatter(getValue('priceCommodity', args.data))}`;
        }

        if (
            ((args.column as Column).field === 'pricePallet' &&
                args.data &&
                args.cell) ||
            ((args.column as Column).field === 'pricePallet' &&
                args.data &&
                args.cell)
        ) {
            let nFormatter = intl.getNumberFormat({
                skeleton: 'C3',
                currency: 'USD',
                minimumIntegerDigits: 0,
                minimumFractionDigits: 2,
            });

            args.cell.innerHTML =
                args?.data?.pricingType === 'Percent'
                    ? `${nFormatter(getValue('pricePallet', args.data))}%`
                    : `$${nFormatter(getValue('pricePallet', args.data))}`;
        }
        if (
            (args.column as Column).field === 'binPrice' &&
            args.data &&
            args.cell
        ) {
            //console.log(args.column.field);
            let nFormatter = intl.getNumberFormat({
                skeleton: 'C3',
                currency: 'USD',
                minimumIntegerDigits: 0,
                minimumFractionDigits: 2,
            });

            args.cell.innerHTML =
                args?.data?.pricingType === 'Percent'
                    ? `${nFormatter(getValue('binPrice', args.data))}%`
                    : `$${nFormatter(getValue('binPrice', args.data))}`;
        }
        if (
            (args.column as Column).field === 'credit' &&
            args.data &&
            args.cell
        ) {
            let nFormatter = intl.getNumberFormat({
                skeleton: 'C3',
                currency: 'USD',
                minimumIntegerDigits: 0,
                minimumFractionDigits: 2,
            });

            args.cell.innerHTML = `$${nFormatter(
                getValue('credit', args.data)
            )}`;
        }

        if (
            (args.column as Column).field === 'totalItemCost' &&
            args.data &&
            args.cell
        ) {
            let nFormatter = intl.getNumberFormat({
                skeleton: 'C3',
                currency: 'USD',
                minimumIntegerDigits: 0,
                minimumFractionDigits: 2,
            });

            args.cell.innerHTML = `$${nFormatter(
                getValue('totalItemCost', args.data)
            )}`;
        }

        if (
            (args.column as Column).field === 'totalItemsCount' &&
            args.data &&
            args.cell
        ) {
            let nFormatter = intl.getNumberFormat({
                skeleton: 'C3',
                currency: 'USD',
                minimumIntegerDigits: 0,
                minimumFractionDigits: 0,
            });

            args.cell.innerHTML = `${nFormatter(
                getValue('totalItemsCount', args.data)
            )}`;
        }

        if (
            (args.column as Column).field === 'rate' &&
            args.data &&
            args.cell
        ) {
            args.cell.innerHTML = `${getValue('rate', args.data)}%`;
        }

        if (
            (args.column as Column).field === 'pricePerBox' &&
            args.data &&
            args.cell
        ) {
            let nFormatter = intl.getNumberFormat({
                skeleton: 'C3',
                currency: 'USD',
                minimumIntegerDigits: 0,
                minimumFractionDigits: 2,
            });
            args.cell.innerHTML = `$${nFormatter(
                getValue('pricePerBox', args.data)
            )}`;
            // args.cell.innerHTML = `$${getValue("fixedRate", args.data)}`;
        }

        if (
            (args.column as Column).field === 'scannedOn' &&
            args.data &&
            args.cell
        ) {
            args.cell.classList.add('text-uppercase');
        }
        if (
            (args.column as Column).field === 'fttenabled' &&
            args.data &&
            args.cell
        ) {
            if (getValue('fttenabled', args.data) === 'Yes') {
                args.cell.innerHTML = `<span class='btnActiveClass'>${getValue(
                    'fttenabled',
                    args.data
                )}</span>`;
            } else {
                args.cell.innerHTML = `<span class='btnActiveNoClassPallet'>${getValue(
                    'fttenabled',
                    args.data
                )}</span>`;
            }
        }
    };

    const handleGetSelectedRowData = async (endpoint: string) => {
        //   //const result = await axios.get(endpoint);
        //   if (result && result?.data) {
        //     dispatch(setRowData([result?.data]));
        //     onRowSelect && onRowSelect([result?.data]);
        //   } else {
        //     alert("Error");
        //   }
        // };

        const result = await axios
            .get(endpoint)
            .then((results: any) => {
                if (results && results.data) {
                    dispatch(setRowData([results?.data]));
                    //     onRowSelect && onRowSelect([result?.data]);
                } else {
                    notify('Failed ', 'error');
                }
            })
            .catch((error: any) => {
                if (tabNameForRow === ContactType.BIN_EXCEPTIONS) {
                    dispatch(setRowData([{ NoRecord: '' }]));
                } else {
                    // if (error.response) {
                    //   notify(error.response?.data?.message, "error");
                    // }
                }
            });
    };

    const onDataBound = () => {
        if (gridRef) {
            gridRef.element.addEventListener('click', onClick.bind(this));
        }
    };

    const onClick = (args: any) => {
        if (args.target.closest('.deleteItem')) {
            var columnText = args.target.innerText;
            // alert("columnText" + " is clicked");
            //handleDelete();
        }
    };

    const handleDelete = (e: any) => {
        // alert("zdf");
        if (gridRef) {
            // alert(JSON.stringify(e.commandColumn));
            e.cancel = true;
            //if (e.commandColumn.type === "Delete") {
            onDelete && onDelete(selectedRow);

            // }
        }
        // //console.log(e);
        //}
    };

    const locationValue = window.location;
    let inInvoicesPath: any;
    let reportsPath: any;
    let inMasterdata: any;
    let inAccessMgmtPath: any;
    let inLLAdminPath: any;
    let scanHistoryPath: any;
    if (locationValue.pathname.indexOf('invoices') > -1) {
        inInvoicesPath = true;
    }
    if (locationValue.pathname.indexOf('reports') > -1) {
        reportsPath = true;
    }
    if (locationValue.pathname.indexOf('masterdata') > -1) {
        inMasterdata = true;
    }
    if (locationValue.pathname.indexOf('accessManagement') > -1) {
        inAccessMgmtPath = true;
    }
    if (locationValue.pathname.indexOf('LLAdmin') > -1) {
        inLLAdminPath = true;
    }
    if (locationValue.pathname.indexOf('scan') > -1) {
        scanHistoryPath = true;
    }
    const handleSelectedRow = (event: any) => {
        // if (inInvoicesPath && isFromInvoice) {
        //   gridRef?.clearSelection();
        // }
        if (inInvoicesPath && isFromInvoice && event?.name === 'rowSelected') {
            gridRef?.clearSelection();
        }
        if (reportsPath) {
            gridRef?.clearSelection();
        }
        if (
            event?.target?.classList?.length === 3 &&
            isFromInvoice === true &&
            isFromInvoice !== undefined
        ) {
            event.cancel = true;
            dispatch(setSelectedIdForCancel(event));
        } else {
            if (
                gridRef &&
                (event?.target?.classList?.contains('e-selectionbackground') ||
                    event?.target?.classList?.contains('e-check'))
            ) {
                const selectedrecords: object[] = gridRef.getSelectedRecords();
                selectedRow = gridRef.getSelectedRecords();

                dispatch(setSelectedRecrdsExport(selectedrecords));

                if (
                    tabNameForRow === ContactType.INVENTORY_CATALOG ||
                    tabNameForRow === ContactType.ITEM_CATALOG ||
                    tabNameForRow === ContactType.RULE_EXCEPTIONS ||
                    tabNameForRow === ContactType.COMPANY_CODES ||
                    tabNameForRow === ContactType.STORES ||
                    tabNameForRow === ContactType.CARRIERS ||
                    tabNameForRow === ContactType.VENDORS ||
                    tabNameForRow === ContactType.CUSTOMERS ||
                    tabNameForRow === ContactType.RECLAIM_CENTERS ||
                    tabNameForRow === ContactType.WAREHOUSES ||
                    tabNameForRow === ContactType.DEPARTMENTS ||
                    tabNameForRow === ContactType.GL_ACCOUNTS ||
                    tabNameForRow === ContactType.COMMODITY_TYPES ||
                    tabNameForRow === ContactType.PALLET_LOCATIONS ||
                    tabNameForRow === ContactType.STORE_DISPOSITIONS ||
                    tabNameForRow === ContactType.CustomWHLoc ||
                    tabNameForRow === ContactType.BIN_EXCEPTIONS
                ) {
                    const endpoint = getTabData(tabNameForRow, event.data.id);
                    dispatch(setRowData([]));
                    handleGetSelectedRowData(endpoint);
                    dispatch(setSelectedRCIdForBin(event.data.reclaimCenterId));
                    dispatch(setRowId(event.data));
                } else {
                    if (
                        selectedrecords &&
                        selectedrecords.length > 0 &&
                        event.name === 'rowSelected'
                    ) {
                        dispatch(setRowData(selectedrecords));
                        dispatch(setRowId(event.data));
                        onRowSelect && onRowSelect(selectedrecords);
                        onRowDeselect && onRowDeselect(selectedrecords);
                    } 
                    // else {
                    //     dispatch(setRowData([]));
                    //     onRowSelect && onRowSelect([]);
                    //     dispatch(setRowId(null));
                    //     onRowDeselect && onRowDeselect([]);
                    // }

                    return false;
                }
            } else if (gridRef) {
                const selectedrecords: object[] = gridRef.getSelectedRecords();
                selectedRow = gridRef.getSelectedRecords();
                dispatch(setSelectedRecrdsExport(selectedrecords));
                onRowDeselect && onRowDeselect(selectedrecords);
                 dispatch(setRowData([]));
                  dispatch(setRowId(null));
                // gridRef.SelectRows(index)
                // dispatch(setRowData(selectedrecords));
            }
        }
        //}, 2000)
        if (gridRef) {
            const selectedrecords: object[] = gridRef.getSelectedRecords();
            selectedRow = gridRef.getSelectedRecords();
            dispatch(setSelectedRecrdsExport(selectedrecords));
            onRowDeselect && onRowDeselect(selectedrecords);
            // gridRef.SelectRows(index)
            // dispatch(setRowData(selectedrecords));
        }
    };

    const selectionOptions: SelectionSettingsModel = {
        checkboxMode: 'ResetOnRowClick',
        mode:
            inInvoicesPath ||
            reportsPath ||
            inMasterdata ||
            inAccessMgmtPath ||
            inLLAdminPath ||
            scanHistoryPath
                ? 'Both'
                : 'Row',
        type: 'Single',
        enableSimpleMultiRowSelection:
            inInvoicesPath ||
            reportsPath ||
            inMasterdata ||
            inAccessMgmtPath ||
            inLLAdminPath ||
            scanHistoryPath
                ? false
                : true,
    };
    const handlePagination = async (tablename: string, pageNo: number) => {
        // const endpoint = getEndPoint(tabNameForRow,pageNo,1000);
        // const result = await axios.get(endpoint).then((data)=>{
        //   if (data) {
        //     let storesArray:any =  data.data;
        //     gridRef.current?.hideSpinner()
        //     dispatch(setCurrentContact(storesArray.content));
        //   } else {
        //     alert("Error");
        //   }
        //});
        // gridRef && gridRef.hideSpinner()
        onPaging && onPaging(pageNo);
    };
    const onFirstGridCreated = () => {
        if (gridRef) {
            //gridRef.current.locale="en-US";
            //   createSpinner({
            //     // Specify the target for the spinner to show
            //     target: document.getElementById('container') as HTMLElement,
            //     width: '30px'
            // });
            // showSpinner(document.getElementById('container') as HTMLElement);
            !hideSpinner && gridRef.showSpinner();
        }
        //createSpinner() method is used to create spinner

        // showSpinner() will make the spinner visible
    };
    const onActionComplete = (args: any) => {
        if (
            tabNameForRow === ContactType.STORES ||
            tabNameForRow === ContactType.VENDORS ||
            tabNameForRow === ContactType.ITEM_CATALOG
        ) {
            if (gridRef) {
                // gridRef.current?.setGridPager(template)
                /** height of the each row */

                // ContactScreenWithTabs.handleGridDataChange('','','')
                //dispatch(setGridConfigForTabs(gridRef));
                const totalcount = gridRef.pageSettings.totalRecordsCount;
                const totalpages =
                    (totalcount as number) /
                    (gridRef.pageSettings.pageSize as number);

                if (gridRef.pageSettings.currentPage === totalpages) {
                    pageNo++;
                    gridRef.showSpinner();
                    handlePagination(ContactType.STORES, pageNo);
                }
                // const rowHeight: number = gridRef.getRowHeight();
                // //console.log(rowHeight)
                // /** Grid height */
                // const gridHeight: number = gridRef.height as number;
                // //console.log(gridHeight)
                // /** initial page size */
                // const pageSize: number = gridRef.pageSettings.pageSize as number;
                // //console.log(pageSize)
                // /** new page size is obtained here */
                // const pageResize: any = (gridHeight - (pageSize * rowHeight)) / rowHeight;
                // //console.log(parseInt(pageResize))
                // gridRef.pageSettings.pageSize = pageSize + Math.round(pageResize);
                // //console.log(pageSize)
                // (document.getElementById('container') as HTMLElement).style.display="none";
            }
        }
    };

    const actionCompleteByUser = (args: any) => {
        // //console.log(args.rows[0].data);
        // //console.log(gridRef)
        // handleSelectedRow(gridRef)
        // dispatch(setRowData(args.rows[0].data));
        onFilter && onFilter(args);
    };

    const rowDataBound = (args: RowDataBoundEventArgs) => {
        // //console.log(args);
        if (args.row) {
            if (getValue('isDeleted', args.data) === 'Yes') {
                args.row.classList.add('trash-row');
            }
        }
    };

    return (
        <>
            {/* <div id="container" className="custom-rolling"><div></div></div> */}
            <GridComponent
                id="FGrid"
                ref={(g) => (gridRef = g)}
                className="ll-grid"
                // enableStickyHeader={true}
                dataSource={data}
                queryCellInfo={customizeCell}
                width={width}
                rowHeight={48}
                height={height}
                created={onFirstGridCreated}
                onClick={onActionComplete}
                allowSorting={allowSorting}
                allowPaging={true}
                filterSettings={FilterOptions}
                allowFiltering={allowFilters}
                selectionSettings={selectionOptions}
                pageSettings={pageOptions}
                rowSelected={(event) => handleSelectedRow(event)}
                rowDeselected={(event) => handleSelectedRow(event)}
                editSettings={editSettings}
                commandClick={(e) => handleDelete(e)}
                actionComplete={actionCompleteByUser}
                rowDataBound={rowDataBound}
            >
                <ColumnsDirective>
                    <ColumnDirective type="checkbox" width="50" />
                    {config.map((col: any) => {
                        return (
                            <ColumnDirective
                                filter={getDefaultFilterOperator(col.dataType)}
                                key={col.field}
                                field={col.field}
                                headerText={col.header}
                                width={col.width ? col.width : '100'}
                                textAlign={col?.textAlign}
                                commands={col?.commands}
                            />
                        );
                    })}
                </ColumnsDirective>
                <Inject services={[Page, Sort, Filter, CommandColumn, Edit]} />
            </GridComponent>
        </>
    );
};
export default GridWrapper;
